<template>
  <div>
    <smart-table ref="smartTable"
                 :headers="headers()"
                 :search-function="searchFunction"
                 preference-key="Project">

      <!-- smart table slot HEADER-ITEM-1: new dialog (activate in the headers) -->
      <template v-slot:HEADER-ITEM-1 v-if="currentUserCanManageCRUD">
        <v-btn @click="openDialog()" color="main" class="white--text" small depressed :style="{ visibility: canReadOnly ? 'hidden' : 'visible' }">
          <v-icon small class="mr-1">mdi-plus</v-icon>
          {{ translations.newButton }}
        </v-btn>
      </template>

      <!-- smart table slot results -->
      <template v-slot:results="{ item: item }">
        <!-- keyCode -->
        <td>
          {{ item.keyCode }}
        </td>

        <!-- label -->
        <td>
          {{ item.label }}
        </td>

        <!-- startDate -->
        <td>
          {{ item.dateStartedStr ? momentDate(item.dateStartedStr) : item.dateStartedStr }}
        </td>

        <!-- endDate -->
        <td>
          {{ item.dateFinishedStr ? momentDate(item.dateFinishedStr) : item.dateFinishedStr }}
        </td>

        <!-- city -->
        <td>
          {{ item.city }}
        </td>

        <!-- province -->
        <td>
          {{ item.province }}
        </td>

        <!-- actions -->
        <td width="100">
          <div class="d-flex justify-space-around">
            <!-- loading -->
            <v-progress-circular v-if="item.loading" :size="15" color="main" indeterminate />

            <!-- edit -->
            <v-icon v-if="!item.loading" @click="openDialog(item)" small class="cursor-pointer" :style="{ visibility: canReadOnly ? 'hidden' : 'visible' }">
              {{ currentUserCanManageCRUD ? 'mdi-square-edit-outline' : 'mdi-open-in-new' }}
            </v-icon>

            <!-- delete -->
            <v-icon v-if="currentUserCanManageCRUD && !item.loading" @click="deleteConfirmation(item)" small color="error lighten-1" class="cursor-pointer" :style="{ visibility: canReadOnly ? 'hidden' : 'visible' }">
              mdi-delete-outline
            </v-icon>
          </div>
        </td>
      </template>
    </smart-table>

    <!-- dialog -->
    <project-save-edit-dialog :item="selectedItem" :show="showDialog" :update="isUpdate"
                              @closeDialog="closeDialog()"
                              @updated="$refs.smartTable.getTableRows()" />
  </div>
</template>


<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { translations } from '@/utils/common'
import { MomentMixin } from '@/utils/mixins/MomentMixin'

import ProjectService from '@/service/project/ProjectService'

import SmartTable from '@/components/SmartTable'
import ProjectSaveEditDialog from '@/views/Project/ProjectSaveEditDialog'

export default {
  name: 'Project',

  components: {
    SmartTable,
    ProjectSaveEditDialog
  },

  data() {
    return {
      translations: translations,

      showDialog: false,
      isUpdate: false,
      selectedItem: {}
    }
  },

  mixins: [MomentMixin],

  computed: {
    ...mapState({
      currentUserCanManageCRUD: state => state.auth.userInfo.account?.capabilities.some(c => c.name === 'Manage CRUD'),
      canReadOnly: state => state.auth.userInfo.account?.capabilities.some(c => c.name === 'Read-only')
    })
  },

  methods: {
    headers() {
      const headers = []

      headers.push({
        type: 'TEXT',
        name: 'keyCode',
        label: translations.code,
        sort: 'keyCode'
      })

      headers.push({
        type: 'TEXT',
        name: 'label',
        label: translations.label,
        sort: 'label'
      })

      headers.push({
        type: 'DATE-PICKER',
        name: 'dateStartedStr',
        label: translations.startDate,
        sort: 'dateStarted'
      })

      headers.push({
        type: 'DATE-PICKER',
        name: 'dateFinishedStr',
        label: translations.endDate,
        sort: 'dateFinished'
      })

      headers.push({
        type: 'TEXT',
        name: 'city',
        label: translations.city,
        sort: 'city'
      })

      headers.push({
        type: 'TEXT',
        name: 'province',
        label: translations.province,
        sort: 'province'
      })

      // actions
      headers.push({
        type: 'HEADER-ITEM-1'
      })

      return headers
    },

    searchFunction(params) {
      return ProjectService.search(params)
    },

    openDialog(item) {
      this.showDialog = true
      this.isUpdate = !!item
      this.selectedItem = item ? _.cloneDeep(item) : {}
    },

    closeDialog() {
      this.showDialog = false
      this.selectedItem = {}
      this.isUpdate = false
    },

    deleteConfirmation(item) {
      if (confirm(translations.areYouSure)) {
        this.deleteItem(item)
      }
    },

    async deleteItem(item) {
      item.loading = true
      await ProjectService.delete({
          projectId: item.id
        })
        .then(() => {
          this.$root.vtoast.show({ message: translations.deletedSuccess })
          this.$refs.smartTable.getTableRows()
        })
        .catch(() => {
          this.$root.vtoast.showError({ message: translations.deletedFailed })
        })
        .finally(() => {
          item.loading = false
        })
    }
  }
}
</script>
